import React, { FC } from 'react';
import styles from './SummaryHistoryItemMobile.module.scss';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import classNames from 'classnames';

interface SummaryHistoryItemTypes {
  item: any;
}

export const SummaryHistoryItemMobile: FC<SummaryHistoryItemTypes> = ({ item }) => {
  // console.log('item', item);
  return (
    <div className={styles.root}>
      <div className={styles.root_top}>
        <span>
          {item.paid_date.split(' ').slice(0, 2).join(' ')} {item.paid_time}
        </span>
        <p
          style={{ textAlign: 'end', paddingRight: 0, fontWeight: 500 }}
          className={classNames(
            styles.root_item__standart,
            item.incoming && styles.green,
          )}>
          {item.incoming ? '+ ' : ''}
          {addSpaceNumber(item.amount)} ₽
        </p>
      </div>
      <p className={styles.root_name}>{item.name}</p>
      <p className={styles.root_description}>{item.description}</p>
    </div>
  );
};
